import axiosInstance from "app/axiosInstance";
import { KeyActionRequestDto } from "../entities/dtos/key-action-request.dto";

export const unblockKey = async ({ accountId, keyId }: KeyActionRequestDto) => {
  try {
    const response = await axiosInstance.post(
      `/accounts/${accountId}/keys/${keyId}/unblock`
    );

    return response.data;
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
